export const GRAPHQL_URL = import.meta.env.VITE_IS_LOCAL
  ? 'http://localhost:4000/graphql'
  : `${window.ENV.HTTP_URL}/management/graphql`

export const GRAPHQL_PUBLIC_URL = import.meta.env.VITE_IS_LOCAL
  ? 'http://localhost:4000/graphql/public'
  : `${window.ENV.HTTP_URL}/management/graphql/public`
